<template>
  <div class="basic_h1_index" v-if="$store.state.myRender.private.H1_isOpen">
    <div class="tooptipPart module_edit_btn" v-if="$store.state.app.view_pattern === 'pc'">
      <my_edit_btn :module="module"></my_edit_btn>
      <div class="my_moduleShow_btn hideContent lineControl" @click="module_isShow" :title="$t('widgets_basic_h1_index_576')"><span class="el-icon-view"></span></div>
    </div>
    <div class="module_text_font_size_frame h1_frame" v-html="text"></div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

export default {
  name: "basic_h1_index",
  data() {
    return {

    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  methods: {},
  computed: {
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor;
    },
    listArr() {
      return this.module.data.listArr;
    },
    text(){
        //这种方法才能使用[style*="font-size:19"]选择器生效
        return `<h1 style="font-size:${this.pc_widgets_infor.fontSize}px;color:${this.pc_widgets_infor.titleColor};font-family:${this.pc_widgets_infor.fontFamily};font-weight:${this.pc_widgets_infor.fsWeight};font-style:${this.pc_widgets_infor.fsItalics};text-decoration:${this.pc_widgets_infor.fontUnderline};text-align:${this.pc_widgets_infor.textAlign};line-height:${this.pc_widgets_infor.lineHeight}px;">${this.listArr.title}</h1>`
    }
  },
  methods:{
      module_isShow(){
          this.$store.state.myRender.private.H1_isOpen = false;
      }
  },
  created() {},
  mounted() {
      setTimeout(()=>{
          this.text_isShow = true;
      },500)
      
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.basic_h1_index{
    min-height:20px;
    .h1_frame{
        width: 100%;
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_h1/index.vue